import { render, staticRenderFns } from "./Extemporaneo.vue?vue&type=template&id=08827688&"
import script from "./Extemporaneo.vue?vue&type=script&lang=js&"
export * from "./Extemporaneo.vue?vue&type=script&lang=js&"
import style0 from "./Extemporaneo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports